var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08333 2.0835H3.89584C5.02084 2.0835 5.90625 3.05225 5.8125 4.16683L4.94792 14.5418C4.80208 16.2397 6.14582 17.6981 7.85416 17.6981H18.9479C20.4479 17.6981 21.7604 16.4689 21.875 14.9793L22.4375 7.16683C22.5625 5.43767 21.25 4.03141 19.5104 4.03141H6.06251",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9271 22.9167C17.6462 22.9167 18.2292 22.3337 18.2292 21.6146C18.2292 20.8955 17.6462 20.3125 16.9271 20.3125C16.208 20.3125 15.625 20.8955 15.625 21.6146C15.625 22.3337 16.208 22.9167 16.9271 22.9167Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 22.9167C9.31287 22.9167 9.89583 22.3337 9.89583 21.6146C9.89583 20.8955 9.31287 20.3125 8.59375 20.3125C7.87463 20.3125 7.29167 20.8955 7.29167 21.6146C7.29167 22.3337 7.87463 22.9167 8.59375 22.9167Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 8.3335H21.875",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.fa8501eedc1fe5f9e022aeda87c2ffe9.svg";
export { ForwardRef as ReactComponent };